import { render, staticRenderFns } from "./advance-fee-accumulation.vue?vue&type=template&id=3aad8482"
import script from "./advance-fee-accumulation.vue?vue&type=script&lang=js"
export * from "./advance-fee-accumulation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports